import DotLoader from './DotLoader.js';
export { default } from './DotLoader.js';
//# sourceMappingURL=index.js.map
